import Block from "domain/Block";
import DateTime from "utils/DateTime";

export default function resizeToReschedule(onRescheduleBlocks) {
  return async (resizeData) => {
    const { eventRecord, changed, startDate, endDate, originalStartDate, originalEndDate } = resizeData;

    if (!changed) return;

    let effectiveStartDate = startDate;
    let effectiveEndDate = endDate;

    if (originalStartDate === startDate) {
      effectiveEndDate = endDate <= startDate ? DateTime.addDuration(startDate, 5, "minutes") : endDate;
    }

    if (originalEndDate === endDate) {
      effectiveStartDate = endDate <= startDate ? DateTime.subtractDuration(endDate, 5, "minutes") : startDate;
    }

    eventRecord.startDate = new Date(effectiveStartDate);
    eventRecord.endDate = new Date(effectiveEndDate);

    await eventRecord.project.commitAsync();

    const block = Block.updateBlock(eventRecord.data.block, {
      endsAt: DateTime.toISO8601(effectiveEndDate),
      startsAt: DateTime.toISO8601(effectiveStartDate),
    });

    onRescheduleBlocks([block]);
  };
}
